const LoadingState = {
  FETCHING: 1,
  AVAILABLE: 2,
  EMPTY: 3,
}

export default LoadingState
